<template>
    <div
        class="box-modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="location-select-modal-label"
        aria-hidden="true"
        data-element="modal-region-list"
    >
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close ui ui-cross" @click="close"></button>
            </div>
            <div class="modal-body">
                <Loader v-if="loading" />
                <div
                    class="modal-location"
                    data-element="modal-location"
                    v-else
                >
                    <div class="row mb-3">
                        <div class="col-sm-12">
                            <form class="modal-location-input-form" data-element="filter-location">
                                <input
                                    type="text"
                                    placeholder="Найдите свой город"
                                    v-model="query"
                                />
                                <i class="ui ui-search"></i>
                            </form>
                        </div>
                    </div>
                    <ul
                        class="locations-cities-list"
                        data-column="4"
                        data-element="locations-cities-list"
                        v-if="filteredBranches.length > 0"
                    >
                        <li
                            data-element="region-select"
                            :key="branch.key"
                            v-for="branch in filteredBranches"
                        >
                            <span
                                class="city-link"
                                data-element="city-link"
                                @click.prevent="selectBranch(branch)"
                            >
                                {{ branch.name }}
                            </span>
                        </li>
                    </ul>
                    <div v-else>
                        Ничего не найдено
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '../../../components/ui/Loader';

export default {
    name: "SelectBranchModal",
    components: {
        Loader
    },
    props: {
        selectedBranches: {
            type: Array
        },
        loadBranchesFunction: {
            type: Function
        },
        selectBranchFunction: {
            type: Function
        }
    },
    data() {
        return {
            loading: false,
            branches: null,
            query: null
        }
    },
    computed: {
        selectedKey () {
            let grouped = {};
            if (Array.isArray(this.selectedBranches)) {
                this.selectedBranches.forEach(branch => {
                    grouped[branch.key] = true;
                })
            }
            return grouped;
        },
        displayBranches () {
            let branches = this.branches;
            if (Array.isArray(branches)) {
              for (let j in branches) {
                if (branches[j]['name'] == '8800') {
                  branches[j]['name'] = '8800 вся Россия'
                }
              }
                return branches.filter(branch => !this.selectedKey[branch.key])
            }
            return [];
        },
        filteredBranches () {
            if (this.query) {
                let regexp = new RegExp(this.query, 'i');
                return this.displayBranches.filter(branch => regexp.test(branch.name))
            }
            return this.displayBranches;
        }
    },
    mounted () {
        this.loading = true;
        this.loadBranchesFunction()
            .then((branches) => {
                this.branches = branches;
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            })
    },
    methods: {
        close() {
            this.$emit('close');
        },
        selectBranch (branch) {
            this.selectBranchFunction(branch);
            this.close();
        }
    }
}
</script>

<style>

</style>